import axiosInstance from '@/core/api'
import {
	CreateGroupRequest,
	CreateGroupResponse,
	CreateMemberRequest,
	CreateMemberResponse,
	GetAllPermissionsResponse,
	GetGroupByIdResponse,
	GetMemberByIdResponse,
	ExportMemberEventLogCsvRequest,
	GetMemberEventLogRequest,
	GetMemberEventLogResponse,
	GetMemberGroupRequest,
	GetMemberGroupResponse,
	GetMemberLoginHistoryRequest,
	GetMemberLoginHistoryResponse,
	GetOperatorMemberListRequest,
	GetOperatorMemberListResponse,
	UpdateGroupRequest,
	UpdateGroupResponse,
	UpdateMemberRequest,
	UpdateMemberResponse,
} from '../../type'
import { OperatorGroupPermission } from '@/schema'

export const getOperatorMemberList = async (
	payload: GetOperatorMemberListRequest,
): Promise<GetOperatorMemberListResponse> => {
	const response = await axiosInstance.get<GetOperatorMemberListResponse>(
		'/admin/operators/get-operators',
		{
			params: payload,
		},
	)
	return response.data
}

export const getMemberGroupList = async (
	payload: GetMemberGroupRequest,
): Promise<GetMemberGroupResponse> => {
	const response = await axiosInstance.get<GetMemberGroupResponse>(
		'/admin/operators/user-groups/get-user-groups',
		{
			params: payload,
		},
	)
	return response.data
}

export const getMemberLoginHistory = async (
	payload: GetMemberLoginHistoryRequest,
): Promise<GetMemberLoginHistoryResponse> => {
	const response = await axiosInstance.get<GetMemberLoginHistoryResponse>(
		'/admin/operators/login-history',
		{
			params: payload,
		},
	)
	return response.data
}

export const getAllPermissions = async (): Promise<
	OperatorGroupPermission[]
> => {
	const response = await axiosInstance.get<GetAllPermissionsResponse>(
		`/admin/operators/user-groups/permissions`,
	)
	return response.data.data
}

export const createGroup = async (
	payload: CreateGroupRequest,
): Promise<CreateGroupResponse> => {
	const response = await axiosInstance.post<CreateGroupResponse>(
		`/admin/operators/user-groups/create-user-group`,
		payload,
	)
	return response.data
}

export const updateGroup = async (
	payload: UpdateGroupRequest,
	id: string,
): Promise<UpdateGroupResponse> => {
	const response = await axiosInstance.patch<UpdateGroupResponse>(
		`/admin/operators/user-groups/update-user-group/${id}`,
		payload,
	)
	return response.data
}

export const getGroupById = async (
	id: string,
): Promise<GetGroupByIdResponse> => {
	const response = await axiosInstance.get<GetGroupByIdResponse>(
		`/admin/operators/user-groups/get-user-group/${id}`,
	)
	return response.data
}

export const createMember = async (
	payload: CreateMemberRequest,
): Promise<CreateMemberResponse> => {
	const response = await axiosInstance.post<CreateMemberResponse>(
		`/admin/operators/create-operator`,
		payload,
	)
	return response.data
}

export const updateMember = async (
	payload: UpdateMemberRequest,
	id: string,
): Promise<UpdateMemberResponse> => {
	const response = await axiosInstance.patch<UpdateMemberResponse>(
		`/admin/operators/update-operator/${id}`,
		payload,
	)
	return response.data
}

export const getMemberById = async (
	id: string,
): Promise<GetMemberByIdResponse> => {
	const response = await axiosInstance.get<GetMemberByIdResponse>(
		`/admin/operators/get-operator/${id}`,
	)
	return response.data
}

export const deleteMember = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(
		`/admin/operators/delete-operator/${id}`,
	)
	return response.data
}

export const deleteGroup = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(
		`/admin/operators/user-groups/delete-user-group/${id}`,
	)
	return response.data
}

export const exportMemberEventLogCsv = async (
	payload: ExportMemberEventLogCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/event-log-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const getMemberEventLog = async (
	payload: GetMemberEventLogRequest,
): Promise<GetMemberEventLogResponse> => {
	const response = await axiosInstance.get<GetMemberEventLogResponse>(
		`/admin/operators/event-log`,
		{
			params: payload,
		},
	)
	return response.data
}
